module.exports = __webpack_public_path__ + "static/media/44.e3e17944.png";